import React from "react";
import styled from "styled-components";

interface SmallTitleProps {
  icon: React.ReactNode;
  title: string;
}

const SmallTitle: React.FC<SmallTitleProps> = ({ icon, title }) => {
  return (
    <SmallTitleStyled>
      <span className="icon">{icon}</span>
      <h3>{title}</h3>
    </SmallTitleStyled>
  );
};

const SmallTitleStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    border-radius: 10px;
    background: var(--background-light-color-2);
    color: var(--primary-color);

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -0.01em;
  }
`;

export default SmallTitle;
